import React, {Component} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledTooltip} from 'reactstrap';
import {validateField} from "../../common/validation";
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import '../../local_node_modules/react-select/dist/react-select.css';
import {isValidERPStock} from "../../common/componentValidation";
import Select from "../../local_node_modules/react-select";

class ERPStockModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			error:{},
			modal:false,
			stock:null,
			saveLoading:false
		};
		this.onChange 	= this.onChange.bind(this);
		this.saveStock 	= this.saveStock.bind(this);
		this.validateField 	= this.validateField.bind(this);
	}

	componentWillMount() {
		let {stock, modal} = this.props;
		if(stock === null){
			stock={
				itemCode: "",
				itemName: "",
				itemUnit: "C62",
				edmItemName:""
			};
		}
		this.setState({ modal,stock});
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let result = validateField(rule, boundary, e.target.value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateClass(id) {
		let {error} = this.state;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let {error} = this.state;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	onChange(e){
		let stock = deepCopyObject(this.state.stock);
		let {name,value} = e.target;
		stock[name] = value;
		this.setState({stock});
	}

	saveStock(e){
		e.preventDefault();
		this.setState({saveLoading:true});
		let data = deepCopyObject(this.state.stock);
		let {error,valid} = isValidERPStock(data);
		if(valid){
			let self= this;
			let params = {
				url:`/connector/writeStock`,
				method:"post",
				data:data
			};
			request(params)
			.then(response => {
				self.setState({saveLoading:false},()=>self.props.listener(response.data));
			})
			.catch(function (error) {
				self.setState({saveLoading:false});
				showAxiosError(error);
			});
		}else{
			this.setState({error,saveLoading:false});
		}
	}

	render() {
		return (
			<Modal isOpen={this.state.modal} toggle={()=>this.props.toggleModal()} size="lg" backdrop={false}>
				<ModalHeader toggle={()=>this.props.toggleModal()} className="justify-content-center">
					<p className="text-center" style={{margin:"0px"}}>Stok Bilgisi</p>
				</ModalHeader>
				<ModalBody>
					<div className="row" style={{ position: 'relative'}}>
						<div className="col-6">
							<div className={"form-group" + this.validateClass("stockType")}>
								<label className="form-control-label">Stok Tipi*</label>
								<Select
									value={this.state.stock.stockType}
									clearable={false}
									id="stockType"
									name="stockType"
									placeholder="Seçiniz..."
									noResultsText="Kayıt bulunamadı."
									onChange={(e) => this.onChange({target:{name:"stockType",value:e.value}})}
									options={[{value:"Ürün",label:"Ürün"},{value:"Hizmet",label:"Hizmet"}]}
								/>
								{this.validateMessage("stockType") !== "" &&
								<UncontrolledTooltip placement="right" target={"stockType"} delay={0}>
									{this.validateMessage("stockType")}
								</UncontrolledTooltip>}
							</div>
						</div>
						<div className="col-6">
							<div className={"form-group" + this.validateClass("itemCode")}>
								<label className="form-control-label">Ürün Kodu*</label>
								<input className="form-control"
									   type="text"
									   data-vlength={"1,45"}
									   id="itemCode"
									   name="itemCode"
									   onBlur={(e)=>this.validateField(e)}
									   onChange={this.onChange}
									   value={this.state.stock.itemCode}/>
								{this.validateMessage("itemCode") !== "" &&
								<UncontrolledTooltip placement="right" target={"itemCode"} delay={0}>
									{this.validateMessage("itemCode")}
								</UncontrolledTooltip>}
							</div>
						</div>
						<div className="col-6">
							<div className={"form-group" + this.validateClass("itemName")}>
								<label className="form-control-label">Ürün/Hizmet Adı*</label>
								<input className="form-control"
									   type="text"
									   data-vlength="1,255"
									   id="itemName"
									   name="itemName"
									   onBlur={(e)=>this.validateField(e)}
									   onChange={this.onChange}
									   value={this.state.stock.itemName}/>
								{this.validateMessage("itemName") !== "" &&
								<UncontrolledTooltip placement="right" target={"itemName"} delay={0}>
									{this.validateMessage("itemName")}
								</UncontrolledTooltip>}
							</div>
						</div>
						<div className="col-6">
							<div className={"form-group" + this.validateClass("itemUnit")}>
								<label className="form-control-label">Ürün Birim Kodu</label>
								<input className="form-control"
									   type="text"
									   data-vlength="1,255"
									   id="itemUnit"
									   name="itemUnit"
									   onBlur={(e)=>this.validateField(e)}
									   onChange={this.onChange}
									   value={this.state.stock.itemUnit}/>
								{this.validateMessage("itemUnit") !== "" &&
								<UncontrolledTooltip placement="right" target={"itemUnit"} delay={0}>
									{this.validateMessage("itemUnit")}
								</UncontrolledTooltip>}
							</div>
						</div>
						<div className="col-6">
							<div className={"form-group" + this.validateClass("edmItemName")}>
								<label className="form-control-label">E-Dönüşüm Ürün Adı</label>
								<input className="form-control"
									   type="text"
									   data-vlength="1,255"
									   id="edmItemName"
									   name="edmItemName"
									   disabled={true}
									   onBlur={(e)=>this.validateField(e)}
									   onChange={this.onChange}
									   value={this.state.stock.edmItemName}/>
								{this.validateMessage("edmItemName") !== "" &&
								<UncontrolledTooltip placement="right" target={"edmItemName"} delay={0}>
									{this.validateMessage("edmItemName")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<nav className="col-sm-12" style={{paddingLeft:"0px", paddingRight:"0px"}}>
						<button type="button" className="col-sm-3 TekBtn vazgec"
								style={{ background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
										 padding: '9px 40px 9px 13px',float: 'left'}}
								onClick={()=>this.props.toggleModal()}>İptal
						</button>

						<button type="button"
								style={{padding: '9px 39px 9px 13px', float: 'right'}}
								disabled={this.state.saveLoading}
								className="col-sm-3 TekBtn kaydet"
								onClick={(e) => this.saveStock(e)}>Kaydet
						</button>
					</nav>
				</ModalFooter>
			</Modal>
		);
	}
}

export default ERPStockModal;

